import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ScheduledReportSpecification from "./ScheduledReportSpecification";
import type ScheduledReportSpecificationRule from "./ScheduledReportSpecificationRule";

@Model()
class ScheduledReportSpecificationSection extends ApplicationRecord {
  static jsonapiType = "scheduled_report_specification_sections";

  @Attr() frequency: string;

  @Attr() position: number;

  @HasMany() rules: ScheduledReportSpecificationRule[];

  @BelongsTo()
  scheduledReportSpecification: ScheduledReportSpecification;

  @Attr() title: string;
}

export default ScheduledReportSpecificationSection;
